/*eslint-disable*/
export default [
    {
        path: 'trainer/games',
        name: 'trainer:games',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "trainer" */'../../components/trainer/Games.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
    },
    {
        path: 'trainer/games/:type/:exerciseId?',
        name: 'browse:game',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "trainer" */'../../components/trainer/browse/BrowseGames.vue'),
        meta: {
            title: 'router.router_trainer',
            type: 'trainer',
        },
        props: true
    },

    {
        path: 'trainer/generator',
        name: 'trainer:generator',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "trainer" */'../../components/trainer/Generator.vue'),
        meta: {
            title: 'router.router_generatorPDF',
            type: 'trainer',
        },
    },
]
